import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl} from "@angular/forms";
import {Community} from "../../_types/communities";
import {LocalStorageService} from "../../_services/local-storage.service";
import {CommunitiesService} from "../../_services/communities.service";
import {SnackbarService} from "../../_services/snackbar.service";

@Component({
    selector: 'app-select-user',
    templateUrl: './select-user.component.html',
    styleUrl: './select-user.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectUserComponent {
    userSearchControl: FormControl = new FormControl();
    filteredUsers: any[] = [];
    typingTimer: any;
    loadingUsers: boolean = false;
    selectedUser: { id: number, username: string } | undefined;
    title: any;

    constructor(protected dialogRef: MatDialogRef<SelectUserComponent>,
                @Inject(MAT_DIALOG_DATA) private data: any,
                private readonly localStorageService: LocalStorageService,
                private readonly communitiesService: CommunitiesService,
                private readonly snackbarService: SnackbarService,
    ) {

        if (data?.title) {
            this.title = data.title
        }

        this.userSearchControl.valueChanges.subscribe(
            (value): void => {
                clearTimeout(this.typingTimer);
                this.typingTimer = setTimeout((): void => {
                    this.loadingUsers = true;
                    let communityId: number | undefined = this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null)?.id;
                    if (communityId) {
                        this.communitiesService.searchSimpleUserList(communityId, value.toLowerCase()).subscribe(r => {
                            this.loadingUsers = false;
                            this.filteredUsers = r.filter((item: any, index: any, self: any): boolean => {
                                // Remove duplicate items
                                return self.indexOf(item) === index;
                            }).map((option: any) => option.user);
                        }, e => {
                            this.snackbarService.openErrorSnackBar(e,)
                            this.loadingUsers = false;
                            this.filteredUsers = []
                        })
                    } else {
                        this.loadingUsers = false;
                        this.filteredUsers = [];
                    }
                }, 500);
            }
        );
    }

    selectUser(event: any): void {
        this.selectedUser = event
        this.userSearchControl.patchValue('');
    }

}
